import { render, staticRenderFns } from "./VRequestStep0.vue?vue&type=template&id=a4b267a4&scoped=true&"
import script from "./VRequestStep0.vue?vue&type=script&lang=js&"
export * from "./VRequestStep0.vue?vue&type=script&lang=js&"
import style0 from "./VRequestStep0.vue?vue&type=style&index=0&id=a4b267a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b267a4",
  null
  
)

export default component.exports